<template>
  <el-dialog :title="$t('modals.feedback.title')"
             custom-class="ta-dialog"
             :visible.sync="visible"
             :show-close="false"
             :close-on-click-modal="false"
             center>
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <div class="ta-dialog_info">
        {{$t('modals.feedback.greeting')}}
        <a href="mailto: info@cdti.ru">info@cdti.ru</a>
      </div>
      <el-form-item :label="$t('modals.feedback.nameLabel')" prop="name">
        <el-input v-model="form.name"/>
      </el-form-item>
      <el-form-item :label="$t('modals.feedback.emailLabel')" prop="email">
        <el-input v-model="form.email"/>
      </el-form-item>
      <el-form-item :label="$t('modals.feedback.phoneLabel')" prop="phone">
        <el-input v-model="form.phone"/>
      </el-form-item>
      <el-form-item :label="$t('modals.feedback.feedbackLabel')" prop="feedback">
        <el-input v-model="form.feedback" type="textarea" :rows="7" resize="none"/>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <div class="ta-dialog_error" v-if="error">
        {{error}}
      </div>
      <el-button @click="visible = false">
        {{$t('modals.feedback.cancelBtn')}}
      </el-button>
      <el-button type="success" @click="submit">
        {{$t('modals.feedback.okBtn')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FeedbackModal',
  props: {
    visible2: {
      type: Boolean
    }
  },
  computed: {
    rules () {
      return {
        name: [{ required: true, message: this.$t('validation.required.label'), trigger: 'blur' }],
        email: [{ required: true, message: this.$t('validation.required.label'), trigger: 'blur' }],
        feedback: [{ required: true, message: this.$t('validation.required.label'), trigger: 'blur' }]
      }
    }
  },
  data () {
    return {
      visible: false,
      error: null,
      form: {
        name: null,
        email: null,
        phone: null,
        feedback: null
      }
    }
  },
  methods: {
    open () {
      this.error = null
      this.form.name = null
      this.form.email = null
      this.form.phone = null
      this.form.feedback = null
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.ruleForm.resetFields) {
          this.$refs.ruleForm.resetFields()
        }
      })
    },
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.error = this.$t('validation.required.errorText')
          return
        }
        axios.post('api/v1/feedback', this.form)
          .then(() => {
            this.$notify({
              message: this.$t('modals.feedback.successText'),
              type: 'success'
            })
            this.visible = false
          })
          .catch(() => {
            this.$notify({
              title: this.$t('errors.title'),
              message: this.$t('errors.serverError'),
              type: 'error'
            })
          })
      })
    }
  }
}
</script>

<style lang="scss">
  .el-dialog {
    @media all and (max-width: 500px) {
      width: 90%;
    }
  }

  .ta-dialog_info {
    word-break: break-word;
  }

  .ta-dialog_error {
    padding-bottom: 25px;
    color: #dc737d;
    font-weight: bold;
  }
</style>
